<template>
  <div class="text-4y-black">
    <div class="pb-4 font-bold md:text-2.5xl md:pb-10 font-lufthansa-head">
      {{ tr('components.sales.summary.title') }}
    </div>

    <div class="space-y-2 text-sm md:text-base xl:text-xl md:space-y-6">
      <div class="flex justify-between font-semibold font-lufthansa-head">
        <div class="mr-3">
          {{ tr('components.sales.summary.totalValue') }}
        </div>
        <div class="flex-shrink-0">
          {{ purchase.voucherDenominationCents | formatCurrency(currency) }}
        </div>
      </div>

      <div class="flex justify-between font-light">
        <div class="mr-3">
          {{ tr('components.sales.summary.totalDue') }}
        </div>
        <div class="flex-shrink-0">
          {{ $store.getters['sales/amountToPayInCents'] | formatCurrency(currency) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VoucherAmountSummary from '~brand-components/base/sale/voucher-amount-summary'

export default VoucherAmountSummary.extend()
</script>
